import { notification } from 'antd'
import {
  listAllOnlineSubmissionUrl,
  singleOnlineSubmissionUrl,
  getSingleCompanyEmailUrl,
  onlineSubmissionEmailUrl,
  onlineSubmissionExportUrl, addActivityUrl, onlineSubmissionActivityUrl
} from '../apis'
import { getToken, customAxios as axios } from '../../../request'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'

export const listAllOnlineSubmission = async (filters) => {
  let config = {
    params: { ...filters },
    ...getToken()
  }
  let { data } = await axios.get(listAllOnlineSubmissionUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
};

export const addActivityFxn = async (valdata) => {
  let config = {
    params: { ...valdata },
    ...getToken()
  }
  let { data } = await axios.post(addActivityUrl(), valdata , getToken())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const singleOnlineSubmission = (id) => async (dispatch) => {
  let config = {
    ...getToken()
  }
  let { data } = await axios.get(singleOnlineSubmissionUrl(id), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const getSingleCompanyEmail = () => async (dispatch) => {
  let config = {
    ...getToken()
  }
  let { data } = await axios.get(getSingleCompanyEmailUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const onlineSubmissionEmail = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(onlineSubmissionEmailUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}


export const getSingleCompanyEmailNew = async () => {
  let config = {
    ...getToken()
  }
  let { data } = await axios.get(getSingleCompanyEmailUrl(), config)
  if (data.error && data.message !== 'Company not find') {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}



export const updateOnlineSubmission = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.put(listAllOnlineSubmissionUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const onlineSubmissionExportFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let {data} = await axios.post(onlineSubmissionExportUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const onlineSubmissionActivityFxn = (valData) => async (dispatch) => {
  let config = {
    params: valData,
    ...getToken()
  }
  let {data} = await axios.get(onlineSubmissionActivityUrl(), config)
  return data
}
